// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {	 
	accesskeyId: 'AKIAIGR2SBDQJRDDFELA',
	production: true,
	isMockEnabled: false, // You have to switch this, when your real back-end is done
	authTokenKey: 'authce9d77b308c149d5992a80073637e4d5',
	frontUrl: 'https://admin.pfged.com/',
	baseURL: 'https://api.pfged.com/api/v1.0/',
	// baseURL: 'http://192.16.5.20:8989/api/v1.0/',
	// baseURLLocal: 'http://192.16.5.20:8989/api/v1.0/',
	audioVideoURL: 'https://api.pfged.com/Resource/VideoAudioSlide/',	
	userrolekeyadmin: '9C8B7C4895FC8653527CEB4196DA5',
	userrolekeyattorney: 'C6C73EF41D8C85CF365E51FD32D1A',
	userrolekeyemployee: 'bkI5c475KQcvXQr8q6OQzxsRXTrIfnhT',
	admin:'admin',
	attorney:'attorney',
	employee:'employee',
};
